module.exports = __webpack_public_path__ + "img/main-fill.1a642aed.svg";